<script lang="ts">
    import 'ol/ol.css';
    import Map from 'ol/Map';
    import Overlay from 'ol/Overlay';
    import View from 'ol/View';
    import Feature from 'ol/Feature';
    import Point from 'ol/geom/Point';
    import { Circle as CircleStyle, Stroke, Style, Fill, Text } from 'ol/style';
    import { OSM, Vector as VectorSource } from 'ol/source';
    import { Tile as TileLayer, Vector as VectorLayer } from 'ol/layer';
    import {fromExtent, circular} from "ol/geom/Polygon";
    import {authFetch} from "../Auth";
    import type {SearchNearTaskData, SearchNearTaskPoint, SearchNearTaskSquare} from "../Types";
    import {fromLonLat_epsg4978, trilaterate, toLonLat_epsg4978} from "../Trilaterate";
    import {fromLonLat, getPointResolution} from "ol/proj";
    import SearchNearContactsFoundedDialog from "../Component/SearchNearContactsFoundedDialog.svelte";
    import {getContext} from "svelte";
    import AddContactAsUserButton from "../Component/AddContactAsUserButton.svelte";
    import {Circle, Polygon} from "ol/geom";
    import {METERS_PER_UNIT} from "ol/proj";
    const { open } = getContext('simple-modal');

    export let params: {
        taskId: string
    }
    let map = null;
    let viewDiv = "map";

    let taskInfoPromise: Promise<any>
    let taskInfo: SearchNearTaskData | null = null;
    let users = {};
    let locatedUsers = [];
    let foundedUsers = 0;
    async function loadTaskInfo() {
        let response = await authFetch(`search-near/task-info/${params.taskId}`, {
            method: 'GET',
        })
        if (response.ok) {
            taskInfo = await response.json() as SearchNearTaskData;
        } else {
            alert(response.statusText)
        }
    }
    function update(){
        taskInfoPromise = loadTaskInfo()
    }

    update();
    let layer = new TileLayer({
        source: new OSM(),
    });
    let sourcePolygon = new VectorSource({
        wrapX: false,
    });
    let vectorPolygon = new VectorLayer({
        source: sourcePolygon,
    });
    let stylePositions = new Style({
        image: new CircleStyle({
            fill: new Fill({
                color: 'rgba(55, 200, 150, 0.5)',
            }),
            stroke: new Stroke({
                width: 2,
                color: 'rgba(255, 5, 5, 1)',
            }),
            radius: 7,
        }),
    });

    let source = new VectorSource({
        wrapX: false,
    });
    let vector = new VectorLayer({
        source: source,
        style: stylePositions,
    });

    let styleUsers = new Style({
        image: new CircleStyle({
            fill: new Fill({
                color: 'rgb(255, 0, 0, 0.4)',
            }),
            stroke: new Stroke({
                width: 2,
                color: 'rgba(0, 0, 0, 0.7)',
            }),
            radius: 12,
        }),
        text: new Text({
            font: '10px Calibri,sans-serif',
            fill: new Fill({ color: '#000' }),
            stroke: new Stroke({
                color: '#fff',
                width: 3,
            }),
        }),
    });

    var sourceUsers = new VectorSource({
        wrapX: false,
    });
    var vectorUsers = new VectorLayer({
        source: sourceUsers,
        style: function (feature) {
            styleUsers.getText().setText(feature.get('name'));
            return styleUsers;
        },
    });


    function addUserMarker(c, text, telegramContactId) {
        var geom = new Point([
            c[0],
            c[1],
        ]);
        var feature = new Feature(geom);
        feature.set('name', text);
        feature.set('telegram_contact_id', telegramContactId);
        sourceUsers.addFeature(feature);
    }
    function zoomToPoint(telegramId) {
        let center = fromLonLat([users[telegramId].location_lon, users[telegramId].location_lat]);
        map.setView(
            new View({
                center: center,
                zoom: 18,
            }),
        )
    }

    function drawCircle(telegramId) {
        let points: SearchNearTaskPoint[] = taskInfo.square.points;


        map.getLayers().getArray()
            .filter(layer =>  layer && layer.get('name') && layer.get('name').indexOf('intersect-circle') != -1)
            .forEach(layer => map.removeLayer(layer));

        let circleCounter = 0;
        for (let i = 0; i < points.length; i++) {
            let distance: number = 0;
            for (let j = 0; j < points[i].contacts.length; j++) {
                if (points[i].contacts[j]['telegram_contact_id'] == telegramId) {
                    distance = parseInt(points[i].contacts[j].distance);
                    break;
                }
            }
            if (distance != 0) {
                let distanceText = 0;
                if (distance == 500) {
                    distanceText = "500 m"
                } else if (distance >= 1000) {
                    distanceText = distance / 1000 + ' km';
                }
                var circleGeometry = circular([points[i].lon, points[i].lat], distance, 64);
                circleGeometry = circleGeometry.transform(
                    "EPSG:4326",
                    "EPSG:3857"
                );
                let polygonCoord = circleGeometry.getCoordinates();
                let layer = new VectorLayer({
                    name: `intersect-circle-${circleCounter}`,
                    source: new VectorSource({
                        features: [
                            new Feature(new Polygon(polygonCoord))
                        ]
                    }),
                    style: new Style({
                        stroke: new Stroke({
                            color: 'rgb(255, 0, 0, 0.7)',
                            width: 2
                        }),
                        fill: new Fill({
                            color: 'rgba(255, 0, 0, 0.1)'
                        }),
                        text: new Text({
                            font: '17px Calibri,sans-serif',
                            fill: new Fill({color: 'rgba(255, 0, 0, 0.1)'}),
                            stroke: new Stroke({
                                color: '#000',
                                width: 0.8,
                            }),
                            text: distanceText
                        })
                    })
                });
                map.addLayer(layer);
                circleCounter += 1;
            }
        }
    }

    function onOpenContactsFounded() {
        open(
            SearchNearContactsFoundedDialog,
            {
                message: "Знайдено в контактах",
                contacts: taskInfo.contacts,
                users: taskInfo.users,

            },
            {
                closeButton: true,
                closeOnEsc: true,
                closeOnOuterClick: true,
                classWindow: 'popupWindowWide'
            }
        );
    }
    const  displayFeatureInfo = (pixel) => {
        vectorUsers.getFeatures(pixel).then(function (features) {
            let feature = features.length ? features[0] : undefined;
            if (features.length) {
                for (let telegramId in users) {
                    if (users[telegramId]['class'] == 'bg-success') {
                        users[telegramId]['class'] = 'bg-info'
                    }
                }
                let telegramContactId = feature.get('telegram_contact_id')
                if (telegramContactId in users) {
                    users[telegramContactId]['class'] = 'bg-success'
                }

            }
        })
    }

    const setupMap = (node, _id) => {
        let square: SearchNearTaskSquare|null = taskInfo?.square ?? null;
        if (!square) {
            console.log('square is not loaded')
            return;
        }
        map = new Map({
            layers: [layer],
            target: _id,
            view: new View({
                center: [parseFloat(square.centerX), parseFloat(square.centerY)],
                zoom: 13,
            }),
        });
        // map.on('pointermove', function (evt) {
        //     if (evt.dragging) {
        //         return;
        //     }
        //     const pixel = map.getEventPixel(evt.originalEvent);
        //     displayFeatureInfo(pixel);
        // });

        map.on('click', function (evt) {
            displayFeatureInfo(evt.pixel);
        });

        map.addLayer(vector);
        map.addLayer(vectorPolygon);
        map.addLayer(vectorUsers);

        let mapExtent = [
            square.minX,
            square.minY,
            square.maxX,
            square.maxY
        ];
        let region = fromExtent(mapExtent);

        let feature = new Feature(region);
        sourcePolygon.addFeature(feature);
        let points: SearchNearTaskPoint[] = square.points;
        for (let i = 0; i < points.length; i++) {
            let geom = new Point([points[i].x, points[i].y]);
            let featurePoint = new Feature(geom);
            sourcePolygon.addFeature(featurePoint);
            for (let j = 0; j < points[i].contacts.length; j++) {
                if (!(points[i].contacts[j]['telegram_contact_id'] in users)) {
                    users[points[i].contacts[j]['telegram_contact_id']] = {
                        'first_name': points[i].contacts[j]['first_name'],
                        'last_name': points[i].contacts[j]['last_name'],
                        'phone': points[i].contacts[j]['phone'],
                        'username': points[i].contacts[j]['username'],
                        'in_points': 0,
                        'located': false,
                        'contact': {
                           'phone': points[i].contacts[j]['phone'],
                            'telegram_contact_id': points[i].contacts[j]['telegram_contact_id'],
                            'username': points[i].contacts[j]['username'],
                            'first_name': square.name,
                            'last_name': `${points[i].contacts[j]['first_name'] ?? ''} ${points[i].contacts[j]['last_name'] ?? ''}`.trim()
                        }
                    }
                    foundedUsers += 1
                }
                if (points[i].contacts[j].location_lat && points[i].contacts[j].location_lon) {
                    users[points[i].contacts[j]['telegram_contact_id']]['location_lat'] = points[i].contacts[j].location_lat
                    users[points[i].contacts[j]['telegram_contact_id']]['location_lon'] = points[i].contacts[j].location_lon
                }
                users[points[i].contacts[j]['telegram_contact_id']]['in_points'] += 1;
            }
        }
        let i = 1
        for (let telegramId in users) {
            users[telegramId]['index'] = i
            users[telegramId]['class'] = ''
            if (users[telegramId].location_lat !== null && users[telegramId].location_lon) {
                users[telegramId]['class'] = 'bg-info'
                users[telegramId]['located'] = true
                let triC = fromLonLat([users[telegramId].location_lon, users[telegramId].location_lat]);
                locatedUsers.push(telegramId)
                addUserMarker(triC, i.toString(), telegramId);
            }
            i += 1
        }
        return {
            destroy() {
                if (map) {
                    map.setTarget(null);
                    map = null;
                }
            }
        }
    }
</script>
<style>
    #sidebar {
        height: 100vh;
        width: 30%;
        float: left;
        text-align: center;
    }

    #settings {
        padding: 20px;
        height: 15vh;
    }

    #map {
        width: 70%;
        height: 100vh;
        overflow: hidden;
    }
    .search-result-box {
        height: 68vh;
        overflow-y: scroll;
    }
</style>

{#await taskInfoPromise}
<div class="text-center">
    <div class="spinner-grow"></div>
</div>
{:then _}
    <div id="sidebar">
        <div id="settings">

            <div class="row">
                <div class="input-group input-group-sm mb-3">
                    <div class="input-group-prepend">
                        <span class="input-group-text">Назва</span>
                    </div>
                    <input type="text" class="form-control" value={taskInfo.square.name} disabled>
                </div>

                <div class="input-group input-group-sm mb-3">
                    <div class="input-group-prepend">
                        <span class="input-group-text">Ширина квадрату (метрів)</span>
                    </div>
                    <input type="number" min="1000" max="10000" class="form-control" value={taskInfo.square.width} disabled>
                </div>
                <div class="input-group input-group-sm mb-3">
                    <div class="input-group-prepend">
                        <span class="input-group-text">Довжина квадрату (метрів)</span>
                    </div>
                    <input type="number" min="1000" max="10000" class="form-control" value={taskInfo.square.height} disabled/>
                </div>
                <div class="input-group input-group-sm mb-3">
                    <div class="input-group-prepend">
                        <span class="input-group-text">Крок сітки (метрів)</span>
                    </div>
                    <input type="number" min="500" max="5000" name="searchDistance" class="form-control" value={taskInfo.square.search_distance} disabled/>
                </div>
                <div class="input-group input-group-sm mb-3 search-result-box">
                    <div class="input-group-prepend">
                        <span class="input-group-text mb-3">Знайдено цілей: {foundedUsers}</span>
                        <button type="button" class="btn btn-primary position-relative" on:click={()=>onOpenContactsFounded()}>
                            Знайдено в контактах
                            <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                            {taskInfo.contacts.length}
                                <span class="visually-hidden">Знайдено в контактах</span>
                            </span>
                        </button>
                    </div>
                    <table class="table table-hover">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>ПІБ</th>
                                <th>TG ID</th>
                                <th>Телефон</th>
                                <th>Username</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {#each Object.entries(users) as [telegramId, user]}
                                <tr class={user.class}>
                                    {#if user.located == true}
                                        <th><button type="button" class="btn btn-outline-secondary btn-sm" on:click={zoomToPoint(telegramId)}>{user.index}</button></th>
                                    {:else}
                                        <th>{user.index ?? '-'}</th>
                                    {/if}
                                    <th>{user.first_name ?? '-'} {user.last_name ?? '-'}</th>
                                    <td>{telegramId ?? '-'}</td>
                                    <td>{user.phone ?? '-'}</td>
                                    <td>{user.username ?? '-'}</td>
                                    <td>
                                        {#if user.phone && user.phone.length > 0}
                                            <AddContactAsUserButton contact="{user.contact}"/>
                                        {/if}
                                        <button type="button" class="btn btn-info btn-sm" on:click={drawCircle(telegramId)}>
                                            <span class="d-inline">{user.in_points}</span>
                                            <i class="d-inline bi bi-pin-map-fill"></i>
                                        </button>
                                    </td>
                                </tr>
                            {/each}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
    <div id={viewDiv} class="map" use:setupMap={viewDiv}></div>
    <div id="mapExtensions" style="display: none;">
        <div id="marker" title="Marker"></div>
        <div id="popup"></div>
    </div>
{:catch error}
    <div class="alert alert-danger">
        {error}<br/>
        Не вдалося завантажити дані завдання {JSON.stringify(params)}
    </div>
{/await}